<template>
  <v-layout column>
    <v-flex>
      <h1 class="H2">{{ $t('pages.content.weekly_schedule') }}</h1>
    </v-flex>

    <v-flex class="py-5">
      <date-buttons
        class="mb-0"
        buttonTextStyle
        :days="days"
        :amountByDate="amountByDate"
        @change="value => selectedDay = value"
        :numberOfDaysToDisplay="numberOfDaysToDisplay"
      />
    </v-flex>

    <v-flex>
      <v-layout v-if="eventsByDay.length" column>
        <v-flex v-for="(event, i) of eventsByDay" :key="`event-${i}`" class="my-2">
          <upcoming-event-details :event="event"/>
        </v-flex>
      </v-layout>

      <h1 v-else class="H3 grey-1--text text-center pt-2 pb-7">
          {{ $t("upcoming_events.no_events") }}
      </h1>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from 'moment'

export default {
  name: 'Agenda',

  props: {
    agenda: {
      type: Array,
      default: [],
    },
  },

  data () {
    return {
      selectedDay: null,
      numberOfDaysToDisplay: 7,
    }
  },

  computed: {
    days () {
      const days = []
      for (let i = 0; i < this.numberOfDaysToDisplay; i++) {
        days.push(moment().add(i, 'd'))
      }
      return days
    },

    amountByDate () {
      let amountByDate = {}

      this.days.map((day) => {
        const formatedDate = day.format('YYYY-MM-DD')
        const dow = day.day()

        amountByDate[formatedDate] = 0

        this.agenda.map(({ availableHours }) => {
          amountByDate[formatedDate] += availableHours.filter((item) => dow === item.dow).length
        })
      })

      return amountByDate
    },

    eventsByDay () {
      let events = []

      this.agenda.map((event) => {
        event.availableHours.map((availableHour) => {
          if (availableHour.dow === moment(this.selectedDay).day()) {
            events.push({
              title: event.title,
              start: availableHour.startHour,
              end: availableHour.endHour,
              location: event.location,
            })
          }
        })
      })

      events = events.sort((a,b) => a.start - b.start)

      return events
    },
  },

  components: {
    DateButtons: () => import('@/components/view-components/webapp-pages/page-objects/DateButtons.vue'),
    UpcomingEventDetails: () => import('@/components/view-components/webapp-pages/upcoming-events/UpcomingEventDetails.vue'),
  },
}
</script>

<style lang="scss"></style>
